/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Plan_Days_ReorderInputs */

const en_us2_offline_kind_plan_days_reorder = /** @type {(inputs: Offline_Kind_Plan_Days_ReorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout order`)
};

const pt_br2_offline_kind_plan_days_reorder = /** @type {(inputs: Offline_Kind_Plan_Days_ReorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordem dos treinos`)
};

const es_419_offline_kind_plan_days_reorder = /** @type {(inputs: Offline_Kind_Plan_Days_ReorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orden de los entrenamientos`)
};

const pt_pt2_offline_kind_plan_days_reorder = /** @type {(inputs: Offline_Kind_Plan_Days_ReorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordem dos treinos`)
};

const fr_fr2_offline_kind_plan_days_reorder = /** @type {(inputs: Offline_Kind_Plan_Days_ReorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordre des séances`)
};

const de_de2_offline_kind_plan_days_reorder = /** @type {(inputs: Offline_Kind_Plan_Days_ReorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge der Trainings`)
};

const it_it2_offline_kind_plan_days_reorder = /** @type {(inputs: Offline_Kind_Plan_Days_ReorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordine degli allenamenti`)
};

/**
* | output |
* | --- |
* | "Workout order" |
*
* @param {Offline_Kind_Plan_Days_ReorderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_plan_days_reorder = /** @type {((inputs?: Offline_Kind_Plan_Days_ReorderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Plan_Days_ReorderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_plan_days_reorder(inputs)
	if (locale === "es-419") return es_419_offline_kind_plan_days_reorder(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_plan_days_reorder(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_plan_days_reorder(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_plan_days_reorder(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_plan_days_reorder(inputs)
	return en_us2_offline_kind_plan_days_reorder(inputs)
});
export { offline_kind_plan_days_reorder as "offline.kind_plan_days_reorder" }